import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Row,
  Modal,
  Card,
  Table,
} from "react-bootstrap";
import update_availability from "../../../assets/images/icons/update_availability.png";
import trash from "../../../assets/images/icons/trash.svg";

import blog_card_img1 from "../../../assets/images/dummy/blog_card_img1.png";
import { useUserContext } from "../../../utils/hooks/UserContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import { addAvailability, deleteCoachAvailableSlot } from "../../../utils/api";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { getCoachBookedAllSlots,deleteCoachAvailableSlot } from "../../../utils/api";
import moment from "moment";
import axios from "axios";
const baseURL = `${process.env.REACT_APP_LOCAL_BASE_URL}`;
function AddAvailabilitySlot1() {
  const navigate = useNavigate();
  const { user } = useUserContext();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [slots, setSlots] = useState([{ id: 1, fromTime: "", toTime: "" }]);
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [updateSlots, setAllSlot] = useState([]);
  const [bookedEvents, setBookedEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [availability_slot_id, setSelectedSessionId] = useState(null);

  const getListData = async () => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-booked-slot-list?type=coach`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "filter",resp.data.data.length);
        if (resp.data.data.length > 0) {
          // setBookedEvents(resp.data.data);
          // console.log("ddddddddddd", bookedEvents);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    if (!availability_slot_id) return;

    try {
      const response = await deleteCoachAvailableSlot({
        availability_slot_id: availability_slot_id,
      });
      console.log("response", response);
      toast.success("Slot Deleted successfully");
    } catch (error) {
      console.error("Error deleting program:", error);
      toast.error("An error occurred while deleting.");
    } finally {
      getListData();
      setShowModal(false);
      setSelectedSessionId(null);
    }
  };

  const openDeleteModal = (id) => {
    setSelectedSessionId(id);
    setShowModal(true);
  };
  useEffect(() => {
    getListData();
  }, [updateSlots]);
  const formatDate = (date) => {
    const isoString = date.toISOString(); // Get ISO format '2024-10-07T07:59:30.000Z'

    // Adjust it to match the required output
    const datePart = isoString.split("T")[0]; // '2024-10-07'
    const timePart = isoString.split("T")[1].split(".")[0]; // '07:59:30'

    return `${datePart}T${timePart}.000000`; // '2024-10-07T07:59:30.000000'
  };

  // const formatTime = (date, time) => {
  //   const isoString = date.toISOString(); // Get ISO format '2024-10-07T07:59:30.000Z'
  //   // Adjust it to match the required output
  //   const datePart = isoString.split("T")[0];

  //   return `${datePart}T${time}:00.000000`;
  // };

  // const updateSlot = async () => {
  //   console.log(":dd",updateSlots)
  //   if(updateSlots.length == 0){
  //       toast.error("please select time slot")
  //   }else{
  //     let counter = 0 ;
  //     for(let i = 0; i < updateSlots.length; i++){
  //       counter++;
  //       await addAvailability(updateSlots[i]);
  //     }
  //     if(counter == updateSlots.length){
  //       toast.success("Slot added successfully!");
  //       navigate("/coach/booking");
  //     }
  //   }
  // }

  // const addSlot = async (item) => {
  //   const newSlot = {
  //     id: slots.length + 1,
  //     fromTime: "",
  //     toTime: "",
  //   };

  //   let check_id = 0;

  //   const payload = {
  //     id: slots.length + 1,
  //     start_time: formatTime(startDate, fromTime),
  //     end_time: formatTime(startDate, toTime),
  //   };
  //   const isConflict =false;
  //   // const isConflict = bookedEvents.some(slot => {
  //   //   const existingStart = new Date(slot.start_time);
  //   //   const existingEnd = new Date(slot.end_time);
  //   //   const newStart = new Date(payload.start_time);
  //   //   const newEnd = new Date(payload.end_time);

  //   //   return (newStart <= existingEnd && newEnd >= existingStart);
  //   // });
  //   if (isConflict) {
  //     setFromTime("")
  //     setToTime("")
  //     removeSlot(check_id)
  //     toast.error("This time slot already exist.");
  //     return;
  //   }else{

  //       const isCheck = updateSlots.some(slot => {
  //       const existingStart = new Date(slot.start_time);
  //       const existingEnd = new Date(slot.end_time);
  //       const newStart = new Date(payload.start_time);
  //       const newEnd = new Date(payload.end_time);
  //   return (newStart <= existingEnd && newEnd >= existingStart);
  //  });

  //   if (isCheck) {
  //     setFromTime("")
  //     setToTime("")
  //     removeSlot(check_id)
  //      toast.error("This time slot overlaps with an existing one.");
  //   }else{
  //     if(item == 'time'){

  //     }else{
  //       setSlots([...slots, newSlot]);
  //       if(fromTime  && toTime){
  //       setAllSlot((prevUpdateSlots) => [...prevUpdateSlots, payload]);
  //       }
  //     }

  //     setFromTime("")
  //     setToTime("")
  //   }
  //   }

  // };

  const updateSlot = async () => {
    console.log("Updated slots:==", slots);
    // return;
    if (slots.length === 0) {
      toast.error("Please select a time slot");
    } else {
      let counter = 0;
      for (let i = 0; i < slots.length; i++) {
        if (!slots[0].fromTime || !slots[0].toTime) {
          toast.error("Please fill at least one time slot");
          return;
        }
        counter++;

        // formatTime(startDate)
        console.log("slots", slots);
        if (slots[i].fromTime && slots[i].toTime) {
          const payload = {
            fromTime: formatTime(slots[i].startDate, slots[i].fromTime),
            toTime: formatTime(slots[i].endDate, slots[i].toTime),
          };
          // console.log(payload);

          const added = await addAvailability(payload);
        }

        //await addAvailability(slots[i]);
      }
      if (counter === slots.length) {
        toast.success("Slots added successfully!");
        setTimeout(() => {
          navigate("/coach/booking");
        }, 2000);
      }
    }
  };

  // Function to format date and time
  const formatTime = (date, time) => {
    const datePart = date.toISOString().split("T")[0];
    return `${datePart}T${time}:00.000000`;
  };

  // Update the 'fromTime' of a specific slot
  const handleFromTime = (id, time) => {
    setFromTime(time);

    setSlots((prevSlots) =>
      prevSlots.map((slot) =>
        slot.id === id
          ? { ...slot, fromTime: time, startDate: startDate }
          : slot
      )
    );
    setAllSlot((prevSlots) =>
      prevSlots.map((slot) =>
        slot.id === id
          ? { ...slot, fromTime: time, startDate: startDate }
          : slot
      )
    );
  };

  // Update the 'toTime' of a specific slot
  const handleToTime = (id, time) => {
    setToTime(time);

    setSlots((prevSlots) =>
      prevSlots.map((slot) =>
        slot.id === id
          ? { ...slot, toTime: time, endDate: endDate ? endDate : startDate }
          : slot
      )
    );
    setAllSlot((prevSlots) =>
      prevSlots.map((slot) =>
        slot.id === id
          ? { ...slot, toTime: time, endDate: endDate ? endDate : startDate }
          : slot
      )
    );
  };

  const addSlot = (item) => {
    // Check if at least one existing slot has a filled field
    const lastSlot = slots[slots.length - 1];
    console.log(lastSlot, fromTime, toTime, "add slots");
    if (!lastSlot || (lastSlot.fromTime && lastSlot.toTime)) {
      const newSlot = {
        id: slots.length + 1,
        fromTime: "", // Initial value for fromTime
        toTime: "", // Initial value for toTime
        date: startDate, // Use a date picker to set date
      };
      let check_id = 0;

      const payload = {
        id: slots.length + 1,
        start_time: formatTime(endDate ? endDate : startDate, fromTime),
        end_time: formatTime(endDate ? endDate : startDate, toTime),
      };
      // const isConflict =false;
      const isConflict = bookedEvents.some((slot) => {
        const existingStart = new Date(slot.start_time);
        const existingEnd = new Date(slot.end_time);
        const newStart = new Date(payload.start_time);
        const newEnd = new Date(payload.end_time);

        return newStart <= existingEnd && newEnd >= existingStart;
      });
      if (isConflict) {
        setFromTime("");
        setToTime("");
        removeSlot(slots.length);
        toast.error("This time slot already exist.");
        return;
      } else {
        const isCheck = updateSlots.some((slot) => {
          const existingStart = new Date(slot.start_time);
          const existingEnd = new Date(slot.end_time);
          const newStart = new Date(payload.start_time);
          const newEnd = new Date(payload.end_time);
          return newStart <= existingEnd && newEnd >= existingStart;
        });

        if (isCheck) {
          console.log(slots[slots.length - 1]);
          setFromTime("");
          setToTime("");
          removeSlot(slots.length);
          toast.error("This time slot overlaps with an existing one.");
          return;
        } else {
          if (item == "time") {
          } else {
            setSlots([...slots, newSlot]);
            if (fromTime && toTime) {
              setAllSlot((prevUpdateSlots) => [...prevUpdateSlots, payload]);
            }
          }
          setFromTime("");
          setToTime("");
        }
      }
      // setSlots([...slots, newSlot]);
      // setAllSlot([...slots, newSlot]);
      // setFromTime("")
      // setToTime("")
    } else {
      // Prevent adding an empty slot and show an alert/toast
      toast.error("Please fill at least one field before adding a new slot.");
    }
  };

  console.log(slots, "---------------------slots");

  // Remove a slot
  const removeSlot = (id) => {
    console.log("idhere", id);
    setSlots(slots.filter((slot) => slot.id !== id));
  };

  console.log("upda", updateSlots);
  // useEffect(() => {
  //   // Assuming `defaultSlots` is an array of pre-existing slots you want to edit
  //   const defaultSlots = [
  //     { id: 1, start_time: "09:00 AM", end_time: "10:00 AM" },
  //   ];
  //   setAllSlot(defaultSlots);
  // }, []);

  // const removeSlot = (id) => {
  //   setSlots(slots.filter((slot) => slot.id !== id));
  //   setAllSlot(updateSlots.filter((slot_id) => slot_id.id !== id));
  // };

  const defaultUserImage = (e) => {
    e.target.src = blog_card_img1;
  };
  // console.log(user);

  const handleBlur = (e) => {
    const fromDate = new Date(
      `1970-01-01T${fromTime.replace(/ (AM|PM)/, " $1")}`
    );
    const toDate = new Date(`1970-01-01T${toTime.replace(/ (AM|PM)/, " $1")}`);

    if (fromDate >= toDate) {
      toast.error("End time must be greater than start time.");
    } else {
      setToTime(toTime);
    }
  };

  // useEffect (() =>{
  //   setSlots((prevSlots) =>
  //     prevSlots.map((slot) =>
  //       slot.id === id ? { ...slot, fromTime: time,startDate:startDate ,endDate : endDate} : slot
  //     )
  //   );
  // },[startDate,endDate])
  console.log(startDate, endDate, "9090909");
  const onChange = (dates) => {
    const [start, end] = dates;
    console.log("datesdatesdatesdates", dates);
    setStartDate(start);
    setEndDate(end);
    // console.log(startDate,endDate)
    // addSlot("time");
  };

  return (
    <>
      <Row className="justify-content-between">
        <Col sm="auto">
          <Button
            variant="success"
            className="rounded-circle"
            onClick={() => navigate("/coach/booking")}
          >
            <i className="bi bi-chevron-left"></i>
          </Button>
        </Col>
        <Col sm="auto">
          <div className="d-flex align-items-center">
            <span>
              <img src={update_availability} />
            </span>
            <h4 className="m-0 fs-20 fw-500 text_brand_color2 ms-2">
              Update Availability
            </h4>
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm="12">
          <h4 className="fs-24 fw-500 text_brand_color2">
            Update your availability
          </h4>
          <p className="fs-12 fw-400">
            Set your availability for each day of week at once{" "}
          </p>
        </Col>
      </Row>
      {["radio"].map((type) => (
        <Row className="my-4">
          <Col sm="6">
            <Card className="w-auto p-3">
              <Row className="user_coach_rd_btn">
                <Col>
                  <Form.Check
                    label="Date wise"
                    name="userType"
                    type={type}
                    id="date_wise"
                    value="Date wise"
                  />
                </Col>
                <Col>
                  <Form.Check
                    label="Day wise"
                    name="userType"
                    type={type}
                    id="day_wise"
                    value="Day wise"
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      ))}

      <section className="dateWise_container">
        <Row>
          <div className="booking-component">
            <ul className="booking_user_list">
              <h5>Added Slots</h5>
              {bookedEvents.length > 0
                ? bookedEvents.map((item) => {
                    // Parse the original time as UTC
                    const adjustedTime = moment.utc(item.start_time);

                    const formattedStartTime = adjustedTime.format(
                      "MMMM Do YYYY, h:mm A"
                    );

                    const adjustedEndTime = moment.utc(item.end_time);

                    const formattedEndTime = adjustedEndTime.format(
                      "MMMM Do YYYY, h:mm A"
                    );
                    return (
                      <li key={item.id}>
                        <div className="booking_user_card">
                          <Row className="my-2 align-items-center">
                            <Col sm="6">
                              <div className="p-2 booking_user_card_lt">
                                <div className="d-flex align-items-center">
                                  <div className="ps-2">
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {formattedStartTime} - {formattedEndTime}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            {item.slot_status === "booked" ? (
                              <Col sm="6">
                                <div className="text-end">
                                  <Button
                                    className="px-4 btn-sm"
                                    variant="success"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    Booked
                                  </Button>
                                </div>
                              </Col>
                            ) : item.slot_status === "un_booked" ? (
                              <Col sm="6">
                                <div className="text-end">
                                  <Button
                                    className="px-4 btn-sm"
                                    variant="danger"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    Un Booked
                                  </Button>
                                  <Button
                                    className="px-4 btn-sm"
                                    variant="trash_"
                                    onClick={() => openDeleteModal(item.id)}
                                  >
                                    <img width={20} src={trash} alt="Delete" />
                                  </Button>
                                </div>
                              </Col>
                            ) : item.slot_status === "cancelled" ? (
                              <Col sm="6">
                                <div className="text-end">
                                  <Button
                                    className="px-4 btn-sm"
                                    variant="secondary"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    Cancelled
                                  </Button>
                                </div>
                              </Col>
                            ) : null}
                          </Row>
                        </div>
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </Row>
        <Row className="mb-4 g-4 align-items-end">
          <Col sm="10">
            <Row>
              <Col sm="4" lg="4">
                <div className="mb-3">
                  <DatePicker
                    selected={startDate}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    // excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5)]}
                    selectsRange
                    inline
                    minDate={new Date()}
                  />
                </div>
              </Col>
              <Col sm="8" lg="8">
                <h4 className="mb-3 fs-20 fw-500">Slots For Available Hours</h4>
                <Row className="align-item-end">
                  <Col sm="8" lg="10">
                    {slots.map((slot) => (
                      <div
                        className="gap-3 slot_avlble align-items-end"
                        key={slot.id}
                      >
                        <div className="slot_list w-100">
                          <InputGroup className="mt-1">
                            <Form.Control
                              type="time"
                              value={slot.fromTime}
                              onChange={(e) =>
                                handleFromTime(slot.id, e.target.value)
                              }
                              onBlur={() => {
                                const now = new Date(); // Get the current date and time
                                const currentTime = now
                                  .toTimeString()
                                  .slice(0, 5); // Get current time in HH:mm format
                                const currentDate = now
                                  .toISOString()
                                  .split("T")[0]; // Get current date in YYYY-MM-DD format
                                const endDate = slot?.endDate
                                  ? slot?.endDate
                                  : slot.startDate;

                                if (
                                  moment(slot.startDate).format(
                                    "YYYY-MM-DD"
                                  ) === currentDate &&
                                  slot.fromTime <= currentTime
                                ) {
                                  handleFromTime(slot.id, "");
                                  toast.error(
                                    "Start time must be greater than the current time."
                                  );
                                  return;
                                }

                                const startDateFormatted = moment(
                                  slot.startDate
                                ).format("YYYY-MM-DD");
                                const endDateFormatted =
                                  moment(endDate).format("YYYY-MM-DD");

                                const fromDateTime = moment(
                                  `${startDateFormatted} ${slot.fromTime}`,
                                  "YYYY-MM-DD hh:mm A"
                                );
                                const toDateTime = moment(
                                  `${endDateFormatted} ${slot.toTime}`,
                                  "YYYY-MM-DD hh:mm A"
                                );
                                console.log("herererer", slot);
                                if (
                                  toDateTime.isSameOrBefore(fromDateTime) &&
                                  slot?.toTime
                                ) {
                                  handleFromTime(slot.id, ""); // Clear the invalid toTime input
                                  toast.error(
                                    "End time must be later than the start time."
                                  );
                                  return;
                                }
                              }}
                            />
                            <InputGroup.Text>To</InputGroup.Text>
                            <Form.Control
                              type="time"
                              value={slot.toTime}
                              onChange={(e) =>
                                handleToTime(slot.id, e.target.value)
                              }
                              onBlur={() => {
                                const now = moment(); // Current date-time

                                const endDate = slot?.endDate
                                  ? slot.endDate
                                  : slot.startDate;
                                const startDateFormatted = moment(
                                  slot.startDate
                                ).format("YYYY-MM-DD");
                                const endDateFormatted =
                                  moment(endDate).format("YYYY-MM-DD");

                                console.log("endDate", slot.startDate);

                                const fromDateTime = moment(
                                  `${startDateFormatted} ${slot.fromTime}`,
                                  "YYYY-MM-DD HH:mm"
                                );
                                const toDateTime = moment(
                                  `${endDateFormatted} ${slot.toTime}`,
                                  "YYYY-MM-DD HH:mm"
                                );

                                // Validation 1: End time must be greater than start time
                                if (fromDateTime.isSameOrAfter(toDateTime)) {
                                  handleToTime(slot.id, "");
                                  toast.error(
                                    "End time must be greater than start time."
                                  );
                                  return;
                                }

                                // Validation 2: End date must be greater than or equal to start date
                                // if (moment(slot.startDate).isAfter(moment(endDate))) {
                                //     handleToTime(slot.id, "");
                                //     toast.error("End date must be greater than or equal to start date.");
                                //     return;
                                // }

                                // Validation 3: If start date is today, start time must be greater than current time
                                if (
                                  moment(slot.startDate).isSame(
                                    moment(),
                                    "day"
                                  ) &&
                                  fromDateTime.isSameOrBefore(now)
                                ) {
                                  handleFromTime(slot.id, "");
                                  toast.error(
                                    "Start time must be greater than the current time."
                                  );
                                  return;
                                }

                                // Validation 4: Start time and end time cannot be the same (even if dates are the same)
                                if (fromDateTime.isSame(toDateTime)) {
                                  handleToTime(slot.id, "");
                                  toast.error(
                                    "Start time and end time cannot be the same."
                                  );
                                  return;
                                }
                              }}
                            />
                          </InputGroup>
                        </div>

                        <Button
                          style={{ height: "35px", width: "35px" }}
                          className=""
                          variant="outline-danger"
                          onClick={() => removeSlot(slot.id)}
                        >
                          <i className="fs-20 bi bi-trash"></i>
                        </Button>
                      </div>
                    ))}
                  </Col>
                  <Col className="align-self-end" sm="2" lg="2">
                    <Button
                      style={{ height: "35px", width: "35px" }}
                      variant="outline-success"
                      onClick={addSlot}
                    >
                      <i className="fs-20 bi bi-plus-lg"></i>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-3 justify-content-end">
          <Col sm="3" className="">
            <div className="d-grid text-end">
              <Button className="px-4" variant="success" onClick={updateSlot}>
                Update
              </Button>
            </div>
          </Col>
        </Row>
      </section>
      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this slot?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <hr />
      <section className="dayWise_container">
        <Row>
          <Col>
            <h4 className="mb-3 fs-20 fw-500">Slots For Available Hours</h4>
          </Col>
        </Row>
        <Row className="mb-4 g-4 align-items-end">
          <Col sm="8">
            <Row className="align-items-center">
              <Col sm="3">
                <Form.Check
                  type="checkbox"
                  label="Monday"
                  name="monday"
                  id="monday"
                />
              </Col>
              <Col sm="9">
                {slots.map((slot) => (
                  <div
                    className="gap-3 slot_avlble align-items-end"
                    key={slot.id}
                  >
                    <div className="slot_list w-100">
                      <InputGroup className="mt-1">
                        <Form.Control
                          type="time"
                          value={slot.fromTime}
                          onChange={(e) =>
                            handleFromTime(slot.id, e.target.value)
                          }
                          onBlur={() => {
                            const now = new Date(); // Get the current date and time
                            const currentTime = now.toTimeString().slice(0, 5); // Get current time in HH:mm format
                            const currentDate = now.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
                            const endDate = slot?.endDate
                              ? slot?.endDate
                              : slot.startDate;

                            if (
                              moment(slot.startDate).format("YYYY-MM-DD") ===
                                currentDate &&
                              slot.fromTime <= currentTime
                            ) {
                              handleFromTime(slot.id, "");
                              toast.error(
                                "Start time must be greater than the current time."
                              );
                              return;
                            }

                            const startDateFormatted = moment(
                              slot.startDate
                            ).format("YYYY-MM-DD");
                            const endDateFormatted =
                              moment(endDate).format("YYYY-MM-DD");

                            const fromDateTime = moment(
                              `${startDateFormatted} ${slot.fromTime}`,
                              "YYYY-MM-DD hh:mm A"
                            );
                            const toDateTime = moment(
                              `${endDateFormatted} ${slot.toTime}`,
                              "YYYY-MM-DD hh:mm A"
                            );
                            console.log("herererer", slot);
                            if (
                              toDateTime.isSameOrBefore(fromDateTime) &&
                              slot?.toTime
                            ) {
                              handleFromTime(slot.id, ""); // Clear the invalid toTime input
                              toast.error(
                                "End time must be later than the start time."
                              );
                              return;
                            }
                          }}
                        />
                        <InputGroup.Text>To</InputGroup.Text>
                        <Form.Control
                          type="time"
                          value={slot.toTime}
                          onChange={(e) =>
                            handleToTime(slot.id, e.target.value)
                          }
                          onBlur={() => {
                            const now = moment(); // Current date-time

                            const endDate = slot?.endDate
                              ? slot.endDate
                              : slot.startDate;
                            const startDateFormatted = moment(
                              slot.startDate
                            ).format("YYYY-MM-DD");
                            const endDateFormatted =
                              moment(endDate).format("YYYY-MM-DD");

                            console.log("endDate", slot.startDate);

                            const fromDateTime = moment(
                              `${startDateFormatted} ${slot.fromTime}`,
                              "YYYY-MM-DD HH:mm"
                            );
                            const toDateTime = moment(
                              `${endDateFormatted} ${slot.toTime}`,
                              "YYYY-MM-DD HH:mm"
                            );

                            // Validation 1: End time must be greater than start time
                            if (fromDateTime.isSameOrAfter(toDateTime)) {
                              handleToTime(slot.id, "");
                              toast.error(
                                "End time must be greater than start time."
                              );
                              return;
                            }

                            // Validation 2: End date must be greater than or equal to start date
                            // if (moment(slot.startDate).isAfter(moment(endDate))) {
                            //     handleToTime(slot.id, "");
                            //     toast.error("End date must be greater than or equal to start date.");
                            //     return;
                            // }

                            // Validation 3: If start date is today, start time must be greater than current time
                            if (
                              moment(slot.startDate).isSame(moment(), "day") &&
                              fromDateTime.isSameOrBefore(now)
                            ) {
                              handleFromTime(slot.id, "");
                              toast.error(
                                "Start time must be greater than the current time."
                              );
                              return;
                            }

                            // Validation 4: Start time and end time cannot be the same (even if dates are the same)
                            if (fromDateTime.isSame(toDateTime)) {
                              handleToTime(slot.id, "");
                              toast.error(
                                "Start time and end time cannot be the same."
                              );
                              return;
                            }
                          }}
                        />
                      </InputGroup>
                    </div>

                    <div className="mt-1">
                      <Button
                        style={{ height: "35px", width: "35px" }}
                        className=""
                        variant="outline-danger"
                        onClick={() => removeSlot(slot.id)}
                      >
                        <i className="fs-20 bi bi-trash"></i>
                      </Button>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Col>

          <Col sm="auto">
            <div className="text-end">
              <Button
                style={{ height: "35px", width: "35px" }}
                variant="outline-success"
                onClick={addSlot}
              >
                <i className="fs-20 bi bi-plus-lg"></i>
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="mb-4 g-4 align-items-end">
          <Col sm="8">
            <Row className="align-items-center">
              <Col sm="3">
                <Form.Check
                  type="checkbox"
                  label="Tuesday"
                  name="tuesday"
                  id="tuesday"
                />
              </Col>
              <Col sm="9">
                {slots.map((slot) => (
                  <div
                    className="gap-3 slot_avlble align-items-end"
                    key={slot.id}
                  >
                    <div className="slot_list w-100">
                      <InputGroup className="mt-1">
                        <Form.Control
                          type="time"
                          value={slot.fromTime}
                          onChange={(e) =>
                            handleFromTime(slot.id, e.target.value)
                          }
                          onBlur={() => {
                            const now = new Date(); // Get the current date and time
                            const currentTime = now.toTimeString().slice(0, 5); // Get current time in HH:mm format
                            const currentDate = now.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
                            const endDate = slot?.endDate
                              ? slot?.endDate
                              : slot.startDate;

                            if (
                              moment(slot.startDate).format("YYYY-MM-DD") ===
                                currentDate &&
                              slot.fromTime <= currentTime
                            ) {
                              handleFromTime(slot.id, "");
                              toast.error(
                                "Start time must be greater than the current time."
                              );
                              return;
                            }

                            const startDateFormatted = moment(
                              slot.startDate
                            ).format("YYYY-MM-DD");
                            const endDateFormatted =
                              moment(endDate).format("YYYY-MM-DD");

                            const fromDateTime = moment(
                              `${startDateFormatted} ${slot.fromTime}`,
                              "YYYY-MM-DD hh:mm A"
                            );
                            const toDateTime = moment(
                              `${endDateFormatted} ${slot.toTime}`,
                              "YYYY-MM-DD hh:mm A"
                            );
                            console.log("herererer", slot);
                            if (
                              toDateTime.isSameOrBefore(fromDateTime) &&
                              slot?.toTime
                            ) {
                              handleFromTime(slot.id, ""); // Clear the invalid toTime input
                              toast.error(
                                "End time must be later than the start time."
                              );
                              return;
                            }
                          }}
                        />
                        <InputGroup.Text>To</InputGroup.Text>
                        <Form.Control
                          type="time"
                          value={slot.toTime}
                          onChange={(e) =>
                            handleToTime(slot.id, e.target.value)
                          }
                          onBlur={() => {
                            const now = moment(); // Current date-time

                            const endDate = slot?.endDate
                              ? slot.endDate
                              : slot.startDate;
                            const startDateFormatted = moment(
                              slot.startDate
                            ).format("YYYY-MM-DD");
                            const endDateFormatted =
                              moment(endDate).format("YYYY-MM-DD");

                            console.log("endDate", slot.startDate);

                            const fromDateTime = moment(
                              `${startDateFormatted} ${slot.fromTime}`,
                              "YYYY-MM-DD HH:mm"
                            );
                            const toDateTime = moment(
                              `${endDateFormatted} ${slot.toTime}`,
                              "YYYY-MM-DD HH:mm"
                            );

                            // Validation 1: End time must be greater than start time
                            if (fromDateTime.isSameOrAfter(toDateTime)) {
                              handleToTime(slot.id, "");
                              toast.error(
                                "End time must be greater than start time."
                              );
                              return;
                            }

                            // Validation 2: End date must be greater than or equal to start date
                            // if (moment(slot.startDate).isAfter(moment(endDate))) {
                            //     handleToTime(slot.id, "");
                            //     toast.error("End date must be greater than or equal to start date.");
                            //     return;
                            // }

                            // Validation 3: If start date is today, start time must be greater than current time
                            if (
                              moment(slot.startDate).isSame(moment(), "day") &&
                              fromDateTime.isSameOrBefore(now)
                            ) {
                              handleFromTime(slot.id, "");
                              toast.error(
                                "Start time must be greater than the current time."
                              );
                              return;
                            }

                            // Validation 4: Start time and end time cannot be the same (even if dates are the same)
                            if (fromDateTime.isSame(toDateTime)) {
                              handleToTime(slot.id, "");
                              toast.error(
                                "Start time and end time cannot be the same."
                              );
                              return;
                            }
                          }}
                        />
                      </InputGroup>
                    </div>

                    <div className="mt-1">
                      <Button
                        style={{ height: "35px", width: "35px" }}
                        className=""
                        variant="outline-danger"
                        onClick={() => removeSlot(slot.id)}
                      >
                        <i className="fs-20 bi bi-trash"></i>
                      </Button>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Col>

          <Col sm="auto">
            <div className="text-end">
              <Button
                style={{ height: "35px", width: "35px" }}
                variant="outline-success"
                onClick={addSlot}
              >
                <i className="fs-20 bi bi-plus-lg"></i>
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="mt-3 justify-content-end">
          <Col sm="3" className="">
            <div className="d-grid text-end">
              <Button className="px-4" variant="success">
                Update
              </Button>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

export default AddAvailabilitySlot1;
